module.exports = __webpack_public_path__ + "img/stop-a.35adedc0.png";